import { render, staticRenderFns } from "./DelegateMessageDetails.vue?vue&type=template&id=79cac5ef&"
import script from "./DelegateMessageDetails.vue?vue&type=script&lang=js&"
export * from "./DelegateMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports